import { graphql } from "react-relay";

export const draggableWorkingHoursFragments = {
  workingHours: graphql`
    fragment DraggableWorkingHours_workingHours on WorkingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  `,
};
